<template>
  <comment-view></comment-view>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import CommentView from '../Admin/Comments/components/CommentView.vue';

export default defineComponent({
  name: 'UserCommentView',
  components: {
    CommentView,
  },
});
</script>
